module.exports = __webpack_public_path__ + "files/7863e04db81bb50c4474dc6e6ad3cf85.png";